import { ButtonProps, ButtonType, ButtonWidget, TabStyles } from '@tableau/widgets';
import React from 'react';

import { imgPath } from '~common/utilities/ImgUrl';

import { Messages } from '../../codegen/Localize';

export interface LinkedTaskDeleteButtonProps {
  onDelete: () => void;
}

export function LinkedTaskDeleteButton(props: LinkedTaskDeleteButtonProps) {
  const buttonProps: ButtonProps = {
    title: Messages.linkedTasksDeleteLinkedTask(),
    buttonType: ButtonType.Icon,
    testId: 'linked-task-delete-button',
    style: {
      padding: `${TabStyles.Spacing.SmallSpace}px`,
      marginLeft: `${TabStyles.Spacing.SmallSpace}px`,
      width: 26,
      height: 26,
    },
    handleClick: props.onDelete,
  };
  return (
    <ButtonWidget {...buttonProps} aria-label={Messages.linkedTasksDeleteLinkedTask()}>
      <img src={imgPath('trash_14px_small.svg')} alt={Messages.linkedTasksDelete()} />
    </ButtonWidget>
  );
}
